import { bubEvents } from 'shared/events/bub_events';
import { chirpModal } from 'partials/modals/modal';
import { SiteImpressions } from 'shared/events/site_conversion_tracking_helper';

window.chirpModal = chirpModal;

function onCloseButtonClick() {
  window.chirpModal.hideModal();

  bubEvents.track('try again popup', 'dismissed popup');

  // eslint-disable-next-line no-use-before-define
  turnOffEventListeners();
}

function onLinkButtonClick(e) {
  bubEvents.track('try again popup', 'clicked link', {
    label: e.target.dataset.label,
    value: e.target.href,
  });
}

function onDocumentClicked(e) {
  const modalEl = document.querySelector('.no-longer-interested-modal');

  if (!modalEl.contains(e.target)) {
    window.chirpModal.hideModal();

    bubEvents.track('try again popup', 'dismissed popup');

    // eslint-disable-next-line no-use-before-define
    turnOffEventListeners();
  }
}

function turnOffEventListeners() {
  $('.no-longer-interested-modal-header-close-button').off('click touch', onCloseButtonClick);
  $(document).off('click touch', onDocumentClicked);
}

$(() => {
  if (document.querySelector('.no-longer-interested-modal')) {
    chirpModal.init();
    SiteImpressions.trackImmediately({ category: 'try again popup', action: 'popup shown' });
    $('.no-longer-interested-modal-header-close-button').on('click touch', onCloseButtonClick);
    $('.no-longer-interested-modal-cta').on('click touch', onLinkButtonClick);
    $(document).on('click touch', onDocumentClicked);
  }
});
